<shell-layout [error_identity]="true">
  <div class="identity__container">
    <img class="error__img" src="assets/img/errors/error__facial-identification.svg" alt="" />

    <ui-text class="error__title" color="blue-500" size="h3" weight="semibold">
      No logramos validar tu rostro
    </ui-text>

    <ui-text class="error__description" color="blue-300">
      Antes de reintentarlo, <br />
      te recomendamos ver este
      <ui-text
        (click)="showVideo()"
        color="information-500"
        weight="bold"
        [underLine]="true"
        class="cursor-pointer"
      >
        video instructivo.
      </ui-text>
    </ui-text>

    <ui-button
      (clicked)="closeModal()"
      class="error__action"
      type="primary"
      label="Reintentar"
    ></ui-button>
  </div>
</shell-layout>
